/**
 * This class abstracts the access to the persistent storage mechanism
 * (other than in the initial constructor) so that we can use a different
 * mechanism if needed.
 *
 * The calls made on the storage class are:
 *  - setItem(key, value)
 *  - getItem(key)
 *  - removeItem(key)
 * 
 * The default storage is windows local storage.
 */

import StoreServiceBase from '../ephemeral-store/base.js'

export default class PersistentStoreService extends StoreServiceBase {
    constructor() {
        super(window && window.localStorage)
    }
}



// WEBPACK FOOTER //
// src/services/persistent-store/index.js